/* global Stripe */
import { mapActions, mapGetters } from "vuex";

import {
  instance,
  createToken,
  setStripeAccount,
} from "vue-stripe-elements-plus-sa";

import { cartManager } from "@/utilities";
import {
  getStripeKey,
  getMessageFromAPIError,
  geMessageByStripeErrorCode,
  getMessageByStripePaymentIntent,
} from "@/utilities/helper";

import { PAYMENT_TYPE, ORDER_TYPE, STEP_STATUS, STEPS } from "@/utilities/enums";
import { stripeOptions } from "@/stripe/config.json";

const stripe = Stripe(process.env.VUE_APP_STRIPE_KEY, {
  apiVersion: process.env.VUE_APP_STRIPE_API_VERSION,
});
export default {
  name: "payment mixin",
  data() {
    return {
      stripeIsMounted: false,
      paymentRequestResult: null,
      canMakePayment: false,
      stripeKey: getStripeKey(),
      stripeOptions,
      availablePaymentMode: [],
    };
  },
  computed: {
    ...mapGetters('locationStore', ["getNativeApplePayStatus", "getNativeGooglePayStatus"]),
  },
  mounted() {
    if (
      stripe &&
      this.selectedLocation.orderSetting.accepts_stripe &&
      !this.getNativeApplePayStatus &&
      !this.getNativeGooglePayStatus
    ) {
      this.createPaymentRequest();
    }
    this.stripeIsMounted = true;
  },
  created() {
    if (this.selectedLocation.orderSetting.accepts_stripe) {
      this.availablePaymentMode.push({
        label: this.$t("button.card_payment"),
        type: PAYMENT_TYPE.Card,
        icon: "/img/card-payment-mode.svg",
      });

      if (this.getNativeApplePayStatus) {
        //-- Native Apple Pay Mode
        this.availablePaymentMode.push({
          label: "Apple Pay",
          type: PAYMENT_TYPE.ApplePay,
          icon: "/img/apple-payment-mode.svg",
        });
      }
      //-- TODO : Enable when Native Google Pay is working
      /*if (this.getNativeGooglePayStatus) {
        //-- Native Google Pay Mode
        this.availablePaymentMode.push({
          label: "Google Pay",
          type: PAYMENT_TYPE.GooglePay,
          icon: "/img/google-payment-mode.svg",
        });
      }*/
      this.initCartPaymentMode();
    }

    //-- Cash Mode
    if (
      this.selectedLocation.orderSetting.accepts_cod &&
      this.newCart.orderType != ORDER_TYPE.Table.id
    ) {
      this.availablePaymentMode.push({
        label: this.$t("button.cash_payment"),
        type: PAYMENT_TYPE.Cash,
        icon: "/img/cash-payment-mode.svg",
      });
    }

    this.$root.$off("PROCESS_NATIVE_PAY");
    this.$root.$on("PROCESS_NATIVE_PAY", (paymentMethodId) => {
      if (!this.processing) {
        this.processNativePayment(paymentMethodId);
      }
    });

    this.$root.$off("NATIVE_PAY_FAILED");
    this.$root.$on("NATIVE_PAY_FAILED", () => {
      this.processing = false;
    });
  },
  methods: {
    ...mapActions('locationStore', [ "saveTrackedOrder"]),
    ...mapActions('userStore', ["fetchUserCardsRequest"]),
    ...mapActions('cartStore', ["clearNewCart"]),
    //*********************** Start Create the PaymentRequest for The Web Apple Pay / Android Pay **************************** */
    createPaymentRequest() {
      let self = this;
      self.paymentRequestResult = stripe.paymentRequest({
        country: "GB",
        currency: "gbp",
        total: {
          label: "Order Payment from : " + self.selectedLocation.name,
          amount: parseInt((self.newCart.orderTotal * 100).toFixed(0)),
        },
      });

      // Check the availability of the Payment Request API first.
      this.paymentRequestResult.canMakePayment().then(function (result) {
        if (result) {
          self.canMakePayment = result;
          if (result.applePay) {
            self.availablePaymentMode.push({
              label: "Apple Pay",
              type: PAYMENT_TYPE.ApplePay,
              icon: "/img/apple-payment-mode.svg",
            });
          } else if (result.googlePay) {
            self.availablePaymentMode.push({
              label: "Google Pay",
              type: PAYMENT_TYPE.GooglePay,
              icon: "/img/google-payment-mode.svg",
            });
          }
          self.initCartPaymentMode();
        }
      });

      this.paymentRequestResult.on("token", function (token) {
        self.newCart.card = token.token;
        self.newCart.card.stripe_source_id = token.token.card.id;

        cartManager
          .generatePaymentObject(self.newCart, self.selectedLocation.id)
          .then((response) => {
            if (self.isAuthenticated) self.postPayment(response, token);
            else self.PostGuestPayment(response, token);
          });
      });

      this.paymentRequestResult.on("cancel", function () {
        self.processing = false;
      });
    },
    //*********************** End Create the PaymentRequest for The Web Apple Pay / Android Pay **************************** */

    //*********************** Start Create the processPayment for Apple Pay / Android Pay (Native App )**************************** */
    startNativePay() {
      //this.processing = true;
      this.sendMessage({
        payCommand: {
          location: {
            name: this.selectedLocation.name,
            logo: this.selectedLocation.logo,
          },
          visualDetails: {
            orderId: this.newCart.newOrder.id,
            orderTotal: this.newCart.orderTotal,
          },
          details: {
            country: "GB",
            currency: "gbp",
            total: {
              label: `Pay ${this.selectedLocation.name}`, //"Order Payment From : " + this.selectedLocation.name,
              amount: this.newCart.orderTotal,
            },
          },
        },
      });
    },
    processNativePayment(paymentMethodId) {
      this.newCart.paymentMethodId = paymentMethodId;
      cartManager
        .generatePaymentObject(
          this.newCart,
          this.selectedLocation.id,
          this.getNativeApplePayStatus || this.getNativeGooglePayStatus
        )
        .then((response) => {
          if (this.isAuthenticated) this.postPayment(response);
          else this.PostGuestPayment(response);
        });
    },
    //*********************** END Create the processPayment for Apple Pay / Android Pay (in Native App )**************************** */

    //*********************** Start API Invock to send the payment **************************** */
    postPayment(data, token = null) {
      this.makeUserPaymentRequest(data)
        .then((response) => {
          if (response && response.error) {
            this.orderFailed(
              getMessageFromAPIError(response),
              this.$t("button.back_to_checkout")
            );
            return;
          }
          this.newCart.newOrder = response.newOrder.order;
          if (this.newCart.payment_type >= PAYMENT_TYPE.Card) {
            if (
              this.newCart.payment_type == PAYMENT_TYPE.ApplePay &&
              this.getNativeApplePayStatus
            ) {
              this.confirmNativeApplePayment(response.paymentIntent);
            } else {
              if (token) {
                token.complete("success");
              }
              this.newCart.headers = response.headers;
              this.processPaymentIntent(response);
            }
          } else {
            //---- if payment is cash = display success message
            this.orderSucceed();
          }
        })
        .catch((e) => {
          //this.captureException(e);
          if (e && e.data) {
            this.orderFailed(
              getMessageFromAPIError(e.data),
              this.$t("button.back_to_checkout")
            );
          } else {
            this.orderFailed(
              this.$t("generic_error.error_paying_order"),
              this.$t("button.back_to_checkout")
            );
          }
        });
    },

    PostGuestPayment(data, token = null) {
      this.makeGuestPaymentRequest(data)
        .then((response) => {
          if (response && (response.error || !response.newOrder || !response.newOrder.order)) {
            this.orderFailed(
              getMessageFromAPIError(response),
              this.$t("button.back_to_checkout")
            );
            return;
          }

          this.newCart.newOrder = response.newOrder.order;
          if (this.newCart.payment_type >= PAYMENT_TYPE.Card) {
            if (
              this.newCart.payment_type == PAYMENT_TYPE.ApplePay &&
              this.getNativeApplePayStatus
            ) {
              this.confirmNativeApplePayment(response.paymentIntent);
            } else {
              if (token) {
                token.complete("success");
              }
              this.newCart.headers = response.headers;
              this.processPaymentIntent(response);
            }
          } else {
            //---- if payment is cash = display success message
            this.orderSucceed();
          }
        })
        .catch((e) => {
          this.captureException(e);
          if (e && e.data) {
            this.orderFailed(
              getMessageFromAPIError(e.data),
              this.$t("button.back_to_checkout")
            );
          } else {
            this.orderFailed(
              this.$t("generic_error.error_paying_order"),
              this.$t("button.back_to_checkout")
            );
          }
        });
    },
    //*********************** End API Invock to send the payment **************************** */

    //*************************** Start Stripe tokenization confirmation Methods ****************************** */
    tokenize() {
      return new Promise((resolve, reject) => {
        if (this.newCart.payment_type == PAYMENT_TYPE.Card) {
          if (this.newCart.card_id) {
            resolve();
          } else {
            createToken()
              .then((data) => {
                if (data.error) {
                  reject(data.error);
                } else {
                  this.newCart.card = data.token;
                  this.newCart.card.stripe_source_id = data.token.card.id;
                  resolve();
                }
              })
              .catch((e) => {
                this.captureException(e);
                reject(e);
              });
          }
        } else if (this.newCart.payment_type == PAYMENT_TYPE.Cash) {
          this.newCart.card_id = null;
          this.newCart.card = null;
          this.clearCard();
          resolve();
        }
      });
    },
    //*************************** End Stripe tokenization confirmation Methods ****************************** */

    //*************************** Start Stripe payment confirmation Methods ****************************** */
    confirmTheCardPayement() {
      return new Promise((resolve, reject) => {
        setStripeAccount(this.newCart.headers.stripe_account, this.stripeKey);
        instance
          .confirmCardPayment(this.newCart.payment_intent.client_secret)
          .then(function (result) {
            resolve(result);
          })
          .catch((e) => {
            this.captureException(e);
            reject(e);
          });
      });
    },
    confirmNativeApplePayment(paymentIntent) {
      if (
        this.getNativeApplePayStatus &&
        this.newCart.payment_type == PAYMENT_TYPE.ApplePay &&
        paymentIntent &&
        paymentIntent.client_secret
      ) {
        this.sendMessage({
          confirmPayment: {
            status: true,
            client_secret: paymentIntent.client_secret || null,
          },
        });
        this.orderSucceed();
      }
    },
    processPaymentIntent(result) {
      let status = result.paymentIntent ? result.paymentIntent.status : result;

      if (status === "succeeded") {
        this.orderSucceed();
      } else if (
        status === "requires_action" ||
        status === "requires_source_action"
      ) {
        this.newCart.payment_intent = result.paymentIntent;
        cartManager.setCart(this.newCart, false, false);
        //----- get the PayementAttend and confirm the payement
        //--- Clear the card
        let self = this;
        this.confirmTheCardPayement()
          .then((result) => {
            if (result && result.error) {
              this.paymentIntentCanceledRequest({ orderId: self.newCart.id });
              this.orderFailed(
                geMessageByStripeErrorCode(result),
                this.$t("button.back_to_checkout")
              );
              return;
            }

            this.validateOrderRequest({
              orderId: self.newCart.id,
              paymentIntentId: result.paymentIntent.id,
            }).then((response) => {
              if (response.success) {
                this.newCart.newOrder = response.order;
                cartManager.setCart(this.newCart, false, false);
              }
              this.on3DSComplete(result);
            });
          })
          .catch((e) => {
            this.captureException(e);
            this.orderFailed(
              this.$t("message.payment_failed"),
              this.$t("button.back_to_checkout")
            );
          });
      } else if (status.error) {
        this.orderFailed(
          geMessageByStripeErrorCode(status),
          this.$t("button.back_to_checkout")
        );
      } else {
        this.orderFailed(
          getMessageByStripePaymentIntent(status),
          this.$t("button.back_to_checkout")
        );
      }
    },
    on3DSComplete(result) {
      let status = result.paymentIntent ? result.paymentIntent.status : result;

      if (status === "succeeded") {
        // Show your customer that the payment has succeeded
        this.orderSucceed();
      } else if (status.error) {
        this.orderFailed(
          geMessageByStripeErrorCode(status),
          this.$t("button.back_to_checkout")
        );
      } else {
        this.orderFailed(
          getMessageByStripePaymentIntent(status),
          this.$t("button.back_to_checkout")
        );
      }
    },
    //*************************** End Stripe payment confirmation Methods ****************************** */

    //----
    orderSucceed() {
      this.newCart.status = STEP_STATUS.COMPLETED;
      this.newCart.step = STEPS.STEP03;
      cartManager.setCart(this.newCart, false, false);

      //-- save the order for tracking button
      this.saveTrackedOrder({ id: this.newCart.newOrder.id, skip_review: false });

      localStorage.setItem("saved-order", JSON.stringify(this.newCart));
      this.clearNewCart()
      this.processing = false;

      //-- feach the user saved cards to get the new one
      if (this.orderCompleted.save_card) {
        this.fetchUserCardsRequest();
      }
    },
    orderFailed(message, okText = this.$t("button.continue")) {
      let full_message =
        "<p><i class='k-icon-sadface' style='color:" +
        this.staticColor.red +
        "' ></i></p><p>" +
        message +
        "</p>";
      let self = this;
      let options = {
        html: true,
        animation: "fade",
        type: "basic",
        backdropClose: false,
        customClass: "confirm",
        okText: okText,
      };
      self.processing = false;
      this.$dialog.alert(full_message, options).then(function () {
      });
    },
    clearCard() {
      let _cardElement = this.$refs.newCard
        ? this.$refs.newCard.$refs.element._element
        : null;
      if (_cardElement) _cardElement.clear();
    },
    initCartPaymentMode() {
      //-- TODO : Enable when Native Google Pay is working
      /*if(!this.newCart.payment_type){
        this.newCart.payment_type = this.getNativeApplePayStatus || (this.canMakePayment && this.canMakePayment.applePay) ? PAYMENT_TYPE.ApplePay :
                              this.getNativeGooglePayStatus || (this.canMakePayment  && this.canMakePayment.googlePay) ? PAYMENT_TYPE.GooglePay :
                              PAYMENT_TYPE.Card             
      }*/

      if (!this.newCart.payment_type) {
        this.newCart.payment_type =
          this.getNativeApplePayStatus ||
            (this.canMakePayment && this.canMakePayment.applePay)
            ? PAYMENT_TYPE.ApplePay
            : this.canMakePayment && this.canMakePayment.googlePay
              ? PAYMENT_TYPE.GooglePay
              : PAYMENT_TYPE.Card;
      }
    },
  },
};
